import { render, staticRenderFns } from "./studyExam.vue?vue&type=template&id=21b67532&scoped=true&"
import script from "./studyExam.vue?vue&type=script&lang=js&"
export * from "./studyExam.vue?vue&type=script&lang=js&"
import style0 from "./studyExam.vue?vue&type=style&index=0&id=21b67532&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b67532",
  null
  
)

export default component.exports